#import "./broadcast-stub-fragment.graphql"
#import "../../../graphql/fragments/edition-fragment.graphql"

fragment BroadcastFragment on Campaign {
    ...BroadcastStubFragment
    edition {
        ...EditionFragment
    }
    description
    status
}
